import { z } from 'zod'
import { oc } from '@orpc/contract'

// Distinct `/v2/boards-trash` prefix so none of these collide with
// `/v2/boards/{id}` (a GET /v2/boards/trash would match boardGet with id=trash).
export const boardTrashList = oc
  .route({ method: 'GET', path: '/v2/boards-trash' })
  .input(z.object({}).optional())
  .output(
    z.object({
      boards: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
          trashedAt: z.string(),
          deletedBy: z.string().optional(),
          orgId: z.string().optional(),
        }),
      ),
    }),
  )

export const boardRestore = oc
  .route({ method: 'POST', path: '/v2/boards-trash/{id}/restore' })
  .input(z.object({ id: z.string() }))
  .output(z.object({ id: z.string() }))

export const boardPurge = oc
  .route({ method: 'DELETE', path: '/v2/boards-trash/{id}' })
  .input(z.object({ id: z.string() }))
  .output(z.object({ id: z.string() }))
